/**
 * @Author:
 * @Description:
 * @DateTime: Created in 08:56 2019-07-10
 */

import { default as CellOperate } from 'src/components/agGridComponent/cellOperate';
import { ColDefCustom, default as AgGridVueCustomTsx } from 'src/components/agGridCustom/agGridVueCustomTsx';
import _ from 'lodash'
import ListPageService from 'src/types/ListPage';
import override from 'src/dectorators/override';
import { QueryFormVOI } from 'src/components/queryForm/queryForm';
import AuthConfigApi, { AuthConfigDOI } from '../api/authConfigApi'
import AuthConfig from '../authConfig';
import EnumStationType from 'src/enums/enumStationType';
import alertAuthConfigModal from '../authconfigModal';
import { Toast } from 'src/util/toast';
import EnumOperates from 'src/enums/enumOperates';
import { Integer } from 'src/types/base';
import { IconBtnItem } from 'src/components/iconBtnGroup/iconBtnGroup';

export default class AuthConfigService extends ListPageService {
    ctx: AuthConfig;
    
    get type() {
        return EnumStationType.findCode(this.ctx.$route.params.type).getId();
    }

    constructor (ctx: AuthConfig) {
        super()
        this.ctx = ctx
    }

    @override
    createColumns (): ColDefCustom [] {
        let t = this
        return [
            {
                headerName: '序列号',
                field: 'mn',
                minWidth: 160,
            },
            {
               headerName: 'SIMID',
               field: 'sim',
               minWidth: 160,
            },
            {
               headerName: '操作',
               field: 'operate',
               minWidth: 400,
               cellRendererFramework: CellOperate,
               cellRendererFrameworkOpt: [
                   {
                       text: '删除',
                       async click(params) {
                           let res = await Toast.confirm();
                           if (!res) {
                               return;
                           }
                           let data: AuthConfigDOI.RowDataI = params.data;
                           await t.delete(data.id);
                       },
                   }
               ],
           },
        ]
   }

    @override
   createBtnGroup(): Array<IconBtnItem> {
       let t = this;
       return [
           {
               text: '新增',
               async onClick() {
                   let res = await alertAuthConfigModal(EnumOperates.Add.getName());
                   if (res) {
                       t.searchTable();
                   }
               },
           },
       ];
   }

   async delete(id: Integer) {
       let { code } = await AuthConfigApi.delete(id);
       if (code === 0) {
           Toast.success('删除成功');
           this.searchTable();
       }
   }

    @override
    creatQueryForm(): QueryFormVOI.DateItemType[] {
        return [];
    }


    @override
    initSearchParams (): void {
        this.ctx.searchParams = {
            ...this.ctx.queryForm.getQueryObj<AuthConfigDOI.QueryRowDataParamsI>(),
            page_index: this.ctx.currentPage,
            page_size: this.ctx.pageSize,
        }
        this.ctx.currentPage = 1
    }

    @override
    async searchTable () {
        let ctx = this.ctx
        let ag = (this.ctx.$refs.ag) as AgGridVueCustomTsx
        ag.showLoading()
        let {code, data} = await AuthConfigApi.searchList({
            ...ctx.searchParams,
            page_size: ctx.pageSize,
            page_index: ctx.currentPage
        })
        ag.hideLoading()

        if (code === 0) {
            ctx.rowData = data.data_info || [];
            ctx.total = data.page_count
        }
    }

}
